import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { Property } from "./property.model";
import { NumberFormat } from "./number-format.model";
/**
 * @class TaxFee
 * @property {number} id
 * @property {Property} property
 * @property {string} name
 * @property {string} type
 * @property {string} items_availability
 * @property {string} reservations_availability
 * @property {string} code
 * @property {string} category
 * @property {string} amount
 * @property {string} amount_type
 * @property {string} charged_on
 */
export class TaxFee extends TranslatableModel {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {

        return [];
    }

    static get TYPE_TAX() {

        return {
            key: 0,
            value: 'TAX'
        };
    }

    static get TYPE_FEE() {

        return {
            key: 1,
            value: 'FEE'
        };
    }

    static get TYPES() {

        return [
            this.TYPE_TAX,
            this.TYPE_FEE
        ];
    }

    static get CATEGORY_EXCLUSIVE() {

        return {
            key: 0,
            value: 'EXCLUSIVE',
            description: 'THIS_TAX_FEE_IS_NOT_INCLUDED_IN_THE_RATE'
        };
    }

    static get CATEGORY_INCLUSIVE() {

        return {
            key: 1,
            value: 'INCLUSIVE',
            description: 'THIS_TAX_FEE_IS_INCLUDED_IN_THE_RATE'
        };
    }

    static get CATEGORIES() {

        return [
            this.CATEGORY_EXCLUSIVE,
            this.CATEGORY_INCLUSIVE
        ];
    }

    static get PERCENTAGE_OF_TOTAL_AMOUNT() {

        return {
            key: 0,
            value: 'PERCENTAGE_OF_TOTAL_AMOUNT'
        };
    }

    static get FIXED_PER_ROOM_NIGHT_ITEM() {

        return {
            key: 1,
            value: 'FIXED_PER_ROOM_NIGHT_ITEM'
        };
    }

    static get FIXED_PER_ACCOMMODATION() {

        return {
            key: 2,
            value: 'FIXED_PER_ACCOMMODATION',
            reservation: true
        };
    }

    static get FIXED_PER_RESERVATION() {

        return {
            key: 3,
            value: 'FIXED_PER_RESERVATION',
            reservation: true
        };
    }

    static get AMOUNT_TYPES() {

        return [
            this.PERCENTAGE_OF_TOTAL_AMOUNT,
            this.FIXED_PER_ROOM_NIGHT_ITEM,
            this.FIXED_PER_ACCOMMODATION,
            this.FIXED_PER_RESERVATION
        ];
    }

    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {

        return value instanceof Property ? value : new Property(value);
    }

    getType(value) {

        if (angular.isUndefined(value)) {

            this.type = this.constructor.TYPE_FEE.key;
        }

        return value;
    }

    getReservationsAvailability(value) {

        if (angular.isUndefined(value)) {

            this.reservations_availability = true;
        }

        return value;
    }

    getCategory(value) {

        if (angular.isUndefined(value)) {

            this.category = this.constructor.CATEGORY_EXCLUSIVE.key;
        }

        return value;
    }
    
    setAmountType(value) {

        if (value === this.constructor.PERCENTAGE_OF_TOTAL_AMOUNT.key) {

            this.amount = String(this.amount).match(/\d{0,2}(\.\d{0,2})?$/)[0];
        }

        return value;
    }

    getAmountType(value) {

        if (angular.isUndefined(value)) {

            this.amount_type = this.constructor.PERCENTAGE_OF_TOTAL_AMOUNT.key;
        }

        return value;
    }

    get amountSymbol() {

        return this.amount_type === this.constructor.PERCENTAGE_OF_TOTAL_AMOUNT.key ?
            '%' : (this.constructor.$rootScope.$lang !== 'en' ? this.property.general_settings.currency.name_ar : this.property.general_settings.currency.name);
    }

    canChargedOn() {

        return this.amount_type === this.constructor.PERCENTAGE_OF_TOTAL_AMOUNT.key
                && this.type === this.constructor.TYPE_TAX.key;
    }

    setIsCharged(value) {

        if (angular.isUndefined(this._instance)) {

            this._instance = true;
            this.charged_on = [];
        }

        return value;
    }

    getIsCharged(value = false) {

        return value;
    }

    setChargedOn(value = []) {

        if (angular.isUndefined(this._instance)) {

            this._instance = true;
            this.is_charged = !!((value || []).length)
        }

        return value;
    }

    getChargedOn(value) {

        return this.is_charged ? value : [];
    }

    setCode(value) {

        return (value || '').replace(/[^0-9]/g, '');
    }
    
    translate(value = '') {

        return this.constructor.$translate.instant(value);
    }

    formatType(value = this.type) {

        return this.translate(((this.constructor.TYPES || []).find(x => value === x.key) || {}).value);
    }

    formatCategory(value = this.category) {

        return this.translate(((this.constructor.CATEGORIES || []).find(x => value === x.key) || {}).value);
    }

    formatAmount(value = this.amount) {

        const formatType = this.amount_type !== this.constructor.PERCENTAGE_OF_TOTAL_AMOUNT.key ?
            this.property.general_settings.currency_format : '1000.00';

        return this.constructor.$sce.trustAsHtml(`${NumberFormat.format(value, formatType)} ${this.amountSymbol}`);
    }

    formatAvailable(value = {}) {

        let availabillity = [];
        if (this.items_availability) {

            availabillity.push('ITEMS');
        }
        if (this.reservations_availability) {

            availabillity.push('RESERVATIONS');
        }

        return this.translate(availabillity.join('_'));
    }

    formatChargedOn(value = this.is_charged) {

        if (this.type !== this.constructor.TYPE_TAX.key) {

            return null;
        }

        return this.translate(!!value ? 'YES' : 'NO');
    }

    static get validationModel() {

        return {
            name: {
                label: 'NAME_IN_ENGLISH'
            },
            name_ar: {
                label: 'NAME_IN_ARABIC'
            },
            amount: {
                label: 'TAX_FEE_AMOUNT'
            }
        };
    }
}

AccessorsMutatorsDecorator('id', 'name', 'name_ar',
        'property', 'type', 'items_availability', 'reservations_availability',
        'code', 'category', 'amount', 'amount_type', 'charged_on', 'is_charged', 'editable')(TaxFee);



// WEBPACK FOOTER //
// ./src/pms-api/models/tax-fee.model.js